import home from './home.reducer';
import map from './map.reducer';
import settlement from './settlement.reducer';
import stripe from './stripe.reducer';

export default {
  home,
  map,
  settlement,
  stripe,
};
